import React from "react";
import Navbar from "components/generales/Navbar";
import FiltrosBalance from "./FiltrosBalance";

import './Balance.css'
import construccion from '../../components/generales/under_constructions.png'
//En construcción, hay que reestructurar componentes y funciones

const BalanceGeneral = () => {
  return (
    <>
      <Navbar />
      <div className="lista-preview">
        <h2>Balance General</h2>
        <p className="parrafo">Consulta tus movimientos</p>
        <FiltrosBalance />
        <img id="enConstruccion" src={construccion} alt="Sitio en construcción" />
      </div>
    </>
  )
};

export default BalanceGeneral;
